import styled from 'styled-components';
import getAcaraColors from 'styleVariables/getAcaraColors';

export default styled.div`
  color: ${getAcaraColors('light').secondaryText};
  position: relative;
  display: inline;
  font-size: 1.2rem;
  line-height: 2rem;
  text-align: left;
`;
